/** Canonical Vistoera V brand mark — static optimized asset from brand master
 * (VISTOERA_NEW_V_BRAND_LOGO_SIDEBAR_REPLACEMENT_P0_V1).
 *
 * Used by Tenant Sidebar and Canvas narrow rail. Do not redraw this mark in CSS/SVG.
 */
import vistoeraVLogo from '../assets/brand/vistoera-v-logo.png'
import vistoeraVLogo2x from '../assets/brand/vistoera-v-logo-2x.png'
import './vistoera-v-logo.css'

export interface VistoeraVLogoProps {
  className?: string
  /** Decorative — parent button owns the accessible name. */
  alt?: string
}

export default function VistoeraVLogo({ className, alt = '' }: VistoeraVLogoProps) {
  const rootClass = ['vistoera-v-logo', className].filter(Boolean).join(' ')
  return (
    <img
      className={rootClass}
      src={vistoeraVLogo}
      srcSet={`${vistoeraVLogo} 1x, ${vistoeraVLogo2x} 2x`}
      alt={alt}
      draggable={false}
      decoding="async"
      data-testid="vistoera-v-logo"
    />
  )
}
